import React, {forwardRef} from "react";

import {Avatar} from "../../avatar";
import {ProfileMenuTrigger} from "./styles";

export type ProfileMenuDropdownTriggerProps = Readonly<{
  open: boolean;
  name: string;
}>;

/** Opens the profile menu on avatar click; no caret (unlike `DropdownMenuButton`). */
export const ProfileMenuDropdownTrigger = forwardRef<
  HTMLButtonElement,
  ProfileMenuDropdownTriggerProps &
    React.ButtonHTMLAttributes<HTMLButtonElement>
>(({open, name, ...rest}, ref) => (
  <ProfileMenuTrigger
    ref={ref}
    type="button"
    data-test-id="userMenu"
    $active={open}
    {...rest}
  >
    <Avatar size={27} name={name} />
  </ProfileMenuTrigger>
));

ProfileMenuDropdownTrigger.displayName = "ProfileMenuDropdownTrigger";
